import React from "react";
import { createGlobalStyle } from "styled-components";
import { GlobalStyles as BaseStyles } from "twin.macro";

const CustomStyles = createGlobalStyle`

        * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;

  }


    body {
  transition: all 0.5s ease-out;
  scrollbar-width: thin;
  scrollbar-color: #d41b1b #374151;
  
  &::-webkit-scrollbar {
    width: 15px;
  }
  &::-webkit-scrollbar-track {
    background: #374151;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #d41b1b;
    border-radius: 14px;
    border: 3px solid #374151;
  }
}
`;

const GlobalStyles = () => (
  <>
    <BaseStyles />
    <CustomStyles />
  </>
);

export default GlobalStyles;
